import {
  AdvancedRegistrationsUsage,
  AppsumoRegistrationsUsage,
  BaseAttendeesStats,
  BaseRegistrationsUsage,
  EssentialsAttendeesStats,
  FreeRegistrationsUsage,
  SelfServeRegistrationsUsage,
} from '@app/graphql';
import { TransactionState } from '@app/store/domain';
import { CurrencyCode } from '@hopin-team/dashboard-shared';

export enum PricingInterval {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
}

export type BillingInfo = {
  planName: string;
  planNameLocale: string;
  organizationName: string;
  pricingInterval?: PricingInterval;
  registrationsUsage?:
    | SelfServeRegistrationsUsage
    | FreeRegistrationsUsage
    | AdvancedRegistrationsUsage
    | AppsumoRegistrationsUsage
    | BaseRegistrationsUsage
    | null;
  isSelfserve?: boolean;
  isAppsumo?: boolean;
  isAdvanced?: boolean;
  paidTicketsAllowed?: boolean;
  hasEventsLite: boolean | null;
  hasEventsPro: boolean | null;
  hasActiveSubscription?: boolean;
  hasPaymentProviderCustomer?: boolean;
  seats: {
    included: number;
    usedIncluded: number;
    additional: number;
    additionalSeatPrice: {
      amount: number;
      currencyCode: CurrencyCode;
    } | null;
    usedAdditional: number;
    total: number;
    usedTotal: number;
  };
  stripeConnectedClientId: string;
  attendeeStats?: BaseAttendeesStats | EssentialsAttendeesStats | null;
  startsAt: string | null;
  endsAt: string | null;
};

export type State = {
  data: BillingInfo;
  stripeUnlink: {
    status: 'idle' | 'processing' | 'success' | 'failed';
  };
} & TransactionState;

export const defaultBillingInfo: BillingInfo = {
  planName: '',
  planNameLocale: '',
  organizationName: '',
  hasActiveSubscription: false,
  hasPaymentProviderCustomer: false,
  hasEventsLite: false,
  hasEventsPro: false,
  seats: {
    included: 0,
    usedIncluded: 0,
    additional: 0,
    additionalSeatPrice: null,
    usedAdditional: 0,
    total: 0,
    usedTotal: 0,
  },
  registrationsUsage: null,
  startsAt: null,
  endsAt: null,
  stripeConnectedClientId: '',
  attendeeStats: null,
  paidTicketsAllowed: false,
  pricingInterval: undefined,
};

export const defaultState: State = {
  data: defaultBillingInfo,
  status: 'idle',
  stripeUnlink: {
    status: 'idle',
  },
};
